import { Link } from "react-router-dom"
import styled from "styled-components"

const Missing = () => {
    return (
        <Container>
            <ErrorCode>404</ErrorCode>
            <Title>Page Not Found</Title>
            <Subtitle>The page you're looking for doesn't exist or has been moved.</Subtitle>
            <HomeLink to="/">Back to Home</HomeLink>
        </Container>
    )
}

export default Missing

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    height: 100dvh;
    padding: 2rem;
    background: #f8f9fb;
`

const ErrorCode = styled.span`
    font-size: 8rem;
    font-weight: 900;
    background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1;
    margin-bottom: 1rem;
`

const Title = styled.h1`
    font-size: 2.8rem;
    font-weight: 800;
    color: #1e1e2d;
    margin-bottom: 0.5rem;
`

const Subtitle = styled.p`
    font-size: 1.5rem;
    color: #71717a;
    margin-bottom: 2.5rem;
    text-align: center;
`

const HomeLink = styled(Link)`
    display: inline-flex;
    background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
    color: white;
    text-decoration: none;
    border-radius: 12px;
    padding: 1.2rem 3rem;
    font-size: 1.5rem;
    font-weight: 600;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(247, 112, 125, 0.3);
    }
`
